import { useMutation } from "react-query";
import Axios from "axios";
import { BookingScheduleInterface } from "../../../features/Booking-Form/typings/booking.types";
import { mergeResourceCalendarScheduleResponse } from "../../../features/Schedule/functions/mergeResourceCalendarScheduleResponse";
import { ResourceCalendarScheduleResponseDto } from "../../../features/Schedule/typings/resource-calendar.types";
import { BookingType } from "../../../features/Booking-Form/typings/booking-inputs";

export type ResourceScheduleByObjectParams = {
  bookingType: BookingType;
  bookingInventoryId: number;
  startDate: string;
  endDate: string;
};

export function useRemoteResourceScheduleByBookingObjectMutation() {
  return useMutation({
    mutationFn: async (
      params: ResourceScheduleByObjectParams
    ): Promise<BookingScheduleInterface[]> => {
      const { data } = await Axios.get<ResourceCalendarScheduleResponseDto>(
        "/booking-schedule/by-booking-object",
        { params }
      );
      return mergeResourceCalendarScheduleResponse(data);
    }
  });
}
